/* Action Types */
export const LOAD_STOREFRONT_ITEMS_FAIL = 'la/domain/storefront/LOAD_FAIL';
export const LOAD_STOREFRONT_ITEMS_REQUEST = 'la/domain/storefront/LOAD_REQUEST';
export const LOAD_STOREFRONT_ITEMS_SUCCESS = 'la/domain/storefront/LOAD_SUCCESS';
